import { Input, Checkbox, Form, Button, Divider, Radio, InputNumber, Select } from "antd";
import { PlusOutlined, MinusOutlined } from "@ant-design/icons";

import ContentPadding from "../ContentConfig/ContentPadding";
import FormCustomIDField from "../ContentConfig/FormCustomIDField";
import TrimmedInput from "../FormCommonField/FormTrimmedInput";
import { ColorPickerFormItem } from "../Image/ImageConf";
import { DEF_FONTS } from "../constanst";
import { useState } from "react";


export default ({ node }) => {
    const [currentGroup, setCurrentGroup] = useState(
      node?.data?.settingsGroup || "label"
    );
  const defalutLabel = node?.data?.label || ""
  return (
    <>
      <Form.Item label="Label" name="label" rules={[{ required: true, max: 256 }]}>
      <TrimmedInput />
      </Form.Item>
      <Form.Item name="hideLabel" valuePropName="checked">
        <Checkbox>Hide Label</Checkbox>
      </Form.Item>
      <FormCustomIDField />
      <Form.Item name="required" valuePropName="checked">
        <Checkbox>Required</Checkbox>
      </Form.Item>
      Rows:
      <Form.List name="rows" label="Rows">
        {(fields, { add, remove }, { errors }) => (
          <>
            {fields.map((field) => {
              return (
                <div
                  key={field.name}
                  style={{ display: "flex", alignItems: "baseline" }}
                >
                  <Form.Item
                    name={[field.name, "label"]}
                    style={{ width: "calc(100% - 60px)" }}
                  >
                    <Input />
                  </Form.Item>
                  <Button
                    icon={<MinusOutlined />}
                    danger
                    size="small"
                    disabled={fields.length <= 1}
                    shape="circle"
                    type="primary"
                    style={{
                      marginTop: 5,
                      marginLeft: 5,
                    }}
                    onClick={() => remove(field.name)}
                  />
                </div>
              );
            })}
            <Form.Item>
              <Form.ErrorList errors={errors} />
              <Button
                type="primary"
                style={{ width: "100%" }}
                onClick={() =>
                  add({ label: "New Rows " + (fields.length + 1) })
                }
                icon={<PlusOutlined />}
              >
                Add Row
              </Button>
            </Form.Item>
          </>
        )}
      </Form.List>
      Columns:
      <Form.List name="cols" label="Column">
        {(fields, { add, remove }, { errors }) => (
          <>
            {fields.map((field) => {
              return (
                <div
                  key={field.name}
                  style={{ display: "flex", alignItems: "baseline" }}
                >
                  <Form.Item
                    name={[field.name, "value"]}
                    style={{ width: "calc(100% - 60px)" }}
                  >
                    <Input />
                  </Form.Item>
                  <Button
                    icon={<MinusOutlined />}
                    danger
                    size="small"
                    disabled={fields.length <= 1}
                    shape="circle"
                    type="primary"
                    style={{
                      marginTop: 5,
                      marginLeft: 5,
                    }}
                    onClick={() => remove(field.name)}
                  />
                </div>
              );
            })}
            <Form.Item>
              <Form.ErrorList errors={errors} />
              <Button
                type="primary"
                style={{ width: "100%" }}
                onClick={() =>
                  add({ value: "New Columns " + (fields.length + 1) })
                }
                icon={<PlusOutlined />}
              >
                Add Column
              </Button>
            </Form.Item>
          </>
        )}
      </Form.List>
      <strong>Style</strong>
      <Divider style={{ margin: "12px 0" }} />

      {/* Settings group toggle with onChange to update currentGroup */}
      <Form.Item
        name="settingsGroup"
        label="Settings for"
        initialValue="label" // Default to "label"
      >
        <Radio.Group
          onChange={(e) => setCurrentGroup(e.target.value)} // Update state on change
        >
          <Radio.Button value="label">For Label</Radio.Button>
          <Radio.Button value="options">For Options</Radio.Button>
        </Radio.Group>
      </Form.Item>

      {/* Label settings group */}
      <div style={{ display: currentGroup === "label" ? "block" : "none" }}>
        <Form.Item
          label="Label horizon alignment"
          name="labelHorizonAlignment"
          initialValue={"start"}
        >
          <Radio.Group buttonStyle="solid">
            <Radio.Button value="start">Left</Radio.Button>
            <Radio.Button value="center">Center</Radio.Button>
            <Radio.Button value="end">Right</Radio.Button>
          </Radio.Group>
        </Form.Item>
        <Form.Item
          label="Label font size"
          name="labelFontSize"
          initialValue={14}
        >
          <InputNumber min={0} max={100} style={{ width: "100%" }} />
        </Form.Item>
        <Form.Item
          label="Label default font"
          name="labelDefaultFont"
          initialValue={"arial"}
        >
          <Select showSearch options={DEF_FONTS} />
        </Form.Item>
        <ColorPickerFormItem
          label="Label font color"
          name="labelFontColor"
          color={node?.data?.labelFontColor || { r: 0, g: 0, b: 0, a: 1 }}
        />
      </div>

      {/* Options settings group */}
      <div style={{ display: currentGroup === "options" ? "block" : "none" }}>
        <Form.Item
          label="Options font size"
          name="optionsFontSize"
          initialValue={14}
        >
          <InputNumber min={0} max={100} style={{ width: "100%" }} />
        </Form.Item>
        <Form.Item
          label="Options default font"
          name="optionsDefaultFont"
          initialValue={"arial"}
        >
          <Select showSearch options={DEF_FONTS} />
        </Form.Item>
        <ColorPickerFormItem
          label="Options font color"
          name="optionsFontColor"
          color={node?.data?.optionsFontColor || { r: 0, g: 0, b: 0, a: 1 }}
        />
      </div>
      <ContentPadding />
    </>
  );
};
